import AppLayout from '@/layout/AppLayout.vue'
const manageRouter = // 管理端
{
  path: '/manage',
  component: AppLayout,
  children: [
    {
      path: '/shipments',
      name: 'shipments',
      select: false,
      component: () => import('@/manage/shipments/index'),
      meta: {
        title: 'Shipments',
        icon: 'table'
      }
    },
	{
	  path: '/billing',
	  name: 'billing',
	  select: false,
	  component: () => import('@/manage/billing/index'),
	  meta: {
	    title: 'Billing',
	    icon: 'table'
	  }
	},
    {
      path: '/produce',
      name: 'My Settings',
      select: true,
      component: AppLayout,
      redirect: '/produce',
      meta: {
        title: 'My Settings',
        icon: 'table'
      },
      children: [
        {
          path: '',
          name: 'profile',
          component: () => import('@/manage/produce/index'),
          meta: {
            title: 'My Settings',
            icon: 'table'
          },
          hidden: true
        },
        {
          path: '/commodities',
          name: 'commodities',
          component: () => import('@/manage/produce/commodities/index'),
          meta: {
            title: 'My Commodities',
            icon: 'table'
          }
        },
        {
          path: '/CompanyProfile',
          name: 'CompanyProfile',
          component: () => import('@/manage/produce/companyProfile/index'),
          meta: {
            title: 'Company profile',
            icon: 'table'
          }
        },
        {
          path: '/AccountDetails',
          name: 'AccountDetails',
          component: () => import('@/manage/produce/accountDetails/index'),
          meta: {
            title: 'Account Details',
            icon: 'table'
          }
        }
      ]
    }
    //   {
    //     path:'/commodities',
    //     name:'商品管理',
    //     component:()=>import('@/manage/produce/commodities/index'),
    //     meta:{
    //         title: "用户中心",
    //         icon: "table",
    //     }
    //   },
  ]
}

export default manageRouter
